import { render, staticRenderFns } from "./ResetEmail.vue?vue&type=template&id=17538126&scoped=true"
import script from "./ResetEmail.vue?vue&type=script&lang=js"
export * from "./ResetEmail.vue?vue&type=script&lang=js"
import style0 from "./ResetEmail.vue?vue&type=style&index=0&id=17538126&prod&scoped=true&lang=css"
import style1 from "./ResetEmail.vue?vue&type=style&index=1&id=17538126&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17538126",
  null
  
)

export default component.exports